module.exports = __webpack_public_path__ + "img/herb-rosemary-190x100.b36daa60.jpg";